@if (loading) {
<div class="as-fixed-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ 'GENERAL.loading' | translate }}...
  </mat-label>
</div>
}
<div class="as-main-container">
  <div class="as-club-banner">
    <h1 class="as-roboto-slab as-font-white">
      {{ 'HOME.TOOLBAR.club' | translate }}
    </h1>
  </div>
  <div class="as-club-container">
    <div class="as-enter-code-row">
      <form
        autocomplete="off"
        class="as-column as-align-center"
        [formGroup]="checkClubForm"
      >
        <h2 class="as-roboto-slab as-font-24">
          {{ 'CLUB.requestPoints' | translate }}
        </h2>
        <mat-form-field
          class="as-number-formfield"
          appearance="outline"
          color="accent"
        >
          <mat-label> {{ 'CLUB.typeYourNumber' | translate }} </mat-label>
          <input
            mask="000000000000"
            maxlength="12"
            matInput
            formControlName="clubCardID"
          />
        </mat-form-field>
        <mat-form-field
          class="as-number-formfield"
          appearance="outline"
          color="accent"
        >
          <mat-label> {{ 'CLUB-ALSUPER.no1' | translate }} </mat-label>
          <input
            mask="00 0000 0000"
            matInput
            maxlength="10"
            formControlName="clubCardNumber"
          />
        </mat-form-field>
        @if (showClubVerifyError) {
        <mat-error>
          {{ 'CLUB.notSameNumber' | translate }}
        </mat-error>
        }
        <br />
        <button
          class="as-read-button"
          mat-flat-button
          color="accent"
          [disabled]="!checkClubForm.valid"
          (click)="onCheckCardPoints()"
        >
          <mat-label class="as-font-white as-font-semibold">
            {{ 'CLUB.read' | translate }}
          </mat-label>
        </button>
      </form>
    </div>
    <div class="as-club-content">
      <h2 class="as-font-24 as-roboto-slab rewards">
        {{ 'CLUB.rewards' | translate }}
      </h2>
      <p class="as-font-18 as-roboto-slab as-font-normal select-zone">
        {{ 'CLUB.select' | translate }}
      </p>
      @if (!mobile) {
      <div class="as-awards-container">
        @for (zone of zonesList; track zone) {
        <div
          class="as-award"
          matRipple
          [class.selected]="selectedZone.value === zone?.zone"
          (click)="onSelectingZone(zone)"
        >
          <mat-label
            class="as-text-align-center as-font-14"
            [innerHtml]="zone.zone | translate"
          >
          </mat-label>
        </div>
        }
      </div>
      } @else {
      <mat-form-field appearance="outline" color="accent" class="as-font">
        <mat-select [formControl]="selectedZone">
          @for (zone of zonesList; track zone) {
          <mat-option value="{{ zone?.zone }}">
            {{ zone.zone | translate }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      <div class="line-divisor"></div>
      <div class="as-awards-cards-container">
        @for (item of awardsList; track item) {
        <div class="as-award-card">
          <div class="as-image-award">
            <img [src]="item?.image" alt="Image de {{ item?.name }}" />
          </div>
          <mat-label class="as-font-14"> {{ item?.name }} </mat-label>
          <p class="as-font-12 as-font-grey-6a">
            {{ reduceText(item.description) }}
          </p>
          <button
            (click)="openRewardModal(item)"
            mat-stroked-button
            class="as-see-button"
            color="accent"
          >
            {{ 'PURCHASE.seeMore' | translate }}
          </button>
        </div>
        }
      </div>
      @if (awardsList.length > 0 && totalPages > 1) {
      <div class="as-pagination">
        <div class="as-back">
          @if (!prev) {
          <mat-icon class="btn-opacity" svgIcon="ic-back-green"> </mat-icon>
          } @else {
          <button
            (click)="backPage()"
            class="as-pointer back-btn as-border-green"
          >
            <mat-icon svgIcon="ic-back-green"></mat-icon>
          </button>
          }
        </div>
        <div class="as-pages">
          <p class="as-font-16 as-poppins-regular-font as-color-gray">
            {{ currentPage }}/{{ totalPages }}
          </p>
        </div>
        <div class="as-next">
          @if (next) {
          <button
            (click)="nextPage()"
            class="as-pointer next-btn as-border-green"
          >
            <mat-icon svgIcon="ic-right-green"></mat-icon>
          </button>
          } @else {
          <mat-icon class="btn-opacity" svgIcon="ic-right-green"></mat-icon>
          }
        </div>
      </div>
      }
      <div class="frame-container">
        <iframe
          class="as-video-frame"
          src="https://www.youtube.com/embed/QkD3z_y4BDo"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div class="as-top-cards">
        <div class="as-card">
          <div class="as-row as-justify-center">
            <h3 class="as-roboto-slab as-font-semibold as-font-18">
              {{ 'CLUB.discountPoints' | translate }}
            </h3>
          </div>
          <br />
          <mat-label
            class="as-font-14"
            [innerHtml]="'CLUB.discountPointsDescription' | translate"
          ></mat-label>
        </div>
        <div class="as-activate-card">
          <img
            class="as-card-promo"
            width="285"
            height="134"
            ngSrc="assets/images/ClubAlsuperCardPromo.webp"
            alt=""
          />
          <img
            width="287"
            height="188"
            class="as-card-preview"
            ngSrc="assets/images/ClubAlsuperCard.webp"
            priority
            alt=""
          />
          @if (alsuperPointsLoading) {
          <div class="as-spinner-green">
            <mat-spinner [diameter]="30"></mat-spinner>
          </div>
          } @if (!alsuperPointsLoading) {
          <button mat-flat-button color="accent" (click)="goToActivate()">
            <mat-label class="as-font-14 as-font-semibold as-font-white">
              {{
                hasMembership
                  ? ('CLUB.updateCard' | translate)
                  : ('CLUB.activateCard' | translate)
              }}
            </mat-label>
          </button>
          }
        </div>
        <div class="as-card">
          <div class="as-row as-justify-center">
            <h3 class="as-roboto-slab as-font-semibold as-font-18">
              {{ 'CLUB.greatPrice' | translate }}
            </h3>
          </div>
          <br />
          <mat-label
            class="as-font-14"
            [innerHtml]="'CLUB.greatPriceDescription' | translate"
          ></mat-label>
        </div>
      </div>
      <mat-label
        class="as-card-details"
        [innerHtml]="'CLUB.cardDetails' | translate"
      ></mat-label>
    </div>
  </div>
</div>
